export default __webpack_public_path__ + "static/2-f2485d9a11e7212838e3735855156090.png";